__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-doc-upload-form'].baseUrl;
import DocUploadForm from './components/DocUploadForm';
export default DocUploadForm;
;
if (!global.BROWSER) {
  DocUploadForm.appConfig = Object.assign({}, DocUploadForm.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}